import { ajax } from 'rxjs/ajax'
import { retry } from 'rxjs/operators'
import envGet from 'Support/Env/Get/EnvGet.support'
import { ServiceHeadersContentTypeJson } from 'Constants/Service/json-headers'
import HttpService from 'Services/Http/Http.service'
import { getOrderIdTrio, Order } from 'types/Order'
import { OrderActivityLog } from 'types/OrderActivityLog'

const BASE_URL = envGet({ key: `REACT_APP_BORAL_BASE_URL` }) as string
const ACTIVITIES_URL = envGet({ key: `REACT_APP_BORAL_ACTIVITIES_URL` }) as string

interface Options {
  authHeaders: any,
  httpService: HttpService,
  order: Order,
}

const getActivityLogService = async (options: Options): Promise<OrderActivityLog[]> => {
  const {
    authHeaders = {},
    httpService,
    order,
  } = options
  const { orderDate, orderId, orderLine } = getOrderIdTrio(order)
  const orderDateAndOrderId = `${orderDate}-${orderId}`
  const url = `${BASE_URL}${ACTIVITIES_URL.replace(`ORDER_ID`, orderDateAndOrderId)}`

  return httpService.get(url, { headers: authHeaders })
}

export default getActivityLogService
